module.exports = __webpack_public_path__ + "static/img/img-logo-himbarsi.878884a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-logo-himbarsi.svg
// module id = +6dd
// module chunks = 36